import React from 'react';
import css from './index.module.scss';
import { Image } from '../Image';

interface TechnologiesProps {
  data: {
    title: string;
    imgUrl: string;
  }[];
}

export const Technologies = (props: TechnologiesProps) => (
  <ul className={css.list}>
    {props.data.map(technology => (
      <li className={css.item} key={technology.title}>
        <Image
          className={css.img}
          src={technology.imgUrl}
          alt={technology.title}
        />
        <span>{technology.title}</span>
      </li>
    ))}
  </ul>
);
